<template>
     <a-spin :spinning="spinning">
        <!-- <small>{{defaultGroups}}</small>
        <hr> -->
        <a-drawer  title="" :width="480" placement="right" @close="onClose2" :visible="modeDrawerVisible">
            <h6 class="heading-small text-muted mb-4">Mode</h6>  
            <form :key="modeFormKey" >
                <base-input :disabled="formType2 == 'editMode'" alternative="" label="Name" placeholder="" v-model="selectedMode.name" input-classes="form-control"/>
                <base-input alternative="" label="Label" placeholder="" v-model="selectedMode.label" input-classes="form-control"/>
                <!-- <base-input alternative="" label="Action"  v-model="selectedMode.action" input-classes="form-control"/> -->
                <base-input alternative="" label="Action" placeholder="">
                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedMode.action" @change="selectedMenuActionChange">
                        <a-select-option v-for="action in actions" :key="action" :value="action">{{action}}</a-select-option>
                    </a-select>
                </base-input>
                
                <base-input alternative="" label="Parameters" placeholder="">
                    <div v-if="this.paramsOptions2.length > 1">
                        <a-select v-if="selectedMode.action != 'payment'" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedButton.params">
                            <a-select-option v-for="param in paramsOptions2" :key="param" :value="param">{{param}}</a-select-option>
                        </a-select>
                        <a-select v-else style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedMode.params">
                            <a-select-option v-for="param in paramsOptions2" :key="param.code" :value="[param.code]">{{param.name}} ({{param.code}})</a-select-option>
                        </a-select>
                    </div>
                    <div v-else>
                        <a-select disabled mode="tags" v-model='selectedMode.params' style="width: 100%;" input-classes="form-control"></a-select>  
                    </div>
                </base-input>

                <!-- <base-input alternative="" label="Parameters" placeholder="">
                    <a-select  mode="tags" v-model='selectedMode.params' style="width: 100%;" placeholder='Please define parameters here' input-classes="form-control"></a-select>  
                </base-input> -->
                <a-switch class="float-right" checked-children="Change on Item Scan" un-checked-children="Change on Item Scan" v-model="selectedMode.ongoingTrans">Enable chnage function key on item scan</a-switch>
                <a-switch class="float-right" checked-children="Enabled" un-checked-children="Enabled" v-model="selectedMode.isEnable"/>

                <br/><br/>
                <div v-if="selectedMode.ongoingTrans == true">
                    <base-input alternative="" label="Label" placeholder="" v-model="ongoing2.label" input-classes="form-control"/>
                    <base-input alternative="" label="Action" placeholder="">
                        <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="ongoing2.action" @change="selectedMenuActionOngoingChange">
                            <a-select-option v-for="action in actions" :key="action" :value="action">{{action}}</a-select-option>
                        </a-select>
                    </base-input>

                    <base-input alternative="" label="Parameters" placeholder="">
                        <div v-if="this.paramsOptions4.length > 1">
                            <a-select v-if="selectedMode.action != 'payment'" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="ongoing2.params">
                                <a-select-option v-for="param in paramsOptions4" :key="param" :value="param">{{param}}</a-select-option>
                            </a-select>
                            <a-select v-else style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="ongoing2.params">
                                <a-select-option v-for="param in paramsOptions4" :key="param.code" :value="[param.code]">{{param.name}} ({{param.code}})</a-select-option>
                            </a-select>
                        </div>
                        <div v-else>
                            <a-select disabled mode="tags" v-model='ongoing2.params' style="width: 100%;" input-classes="form-control"></a-select>  
                        </div>
                    </base-input>
                    <!-- <base-input alternative="" label="Action"  v-model="ongoing2.action" input-classes="form-control"/>
                    <base-input alternative="" label="Parameters" placeholder="">
                        <a-select  mode="tags" v-model='ongoing2.params' style="width: 100%;" placeholder='Please define parameters here' input-classes="form-control"></a-select>  
                    </base-input> -->

                    <a-switch class="float-right" checked-children="Enabled" un-checked-children="Enabled" v-model="ongoing2.isEnable"/>
                </div>
                
                <br/><br/><br/><br/><br/><br/>
                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button v-if="formType2 == 'editMode'" class="btn btn-success" @click.prevent="updateMode()">Save</button>
                    <button v-else class="btn btn-success" @click.prevent="createMode()">Create</button>
                    <!-- <button class="btn" @click.prevent="onClose2">Cancel</button> -->
                </div>
            </form>
        </a-drawer>

        <a-drawer  title="" :width="600" placement="right" @close="onClose" :visible="drawerVisible">
            <!-- {{this.selectedButton}} -->
            <h6 class="heading-small text-muted mb-4">Button</h6>  
            <form>
                <base-input alternative="" label="Label" placeholder="" v-model="selectedButton.label" input-classes="form-control"/>
                <base-input alternative="" label="Action" placeholder="">
                    <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedButton.action" @change="subMenuActionChange">
                        <a-select-option v-for="action in actions" :key="action" :value="action">{{action}}</a-select-option>
                    </a-select>
                </base-input>

                <!-- <base-input alternative="" label="Action"  v-model="selectedButton.action" input-classes="form-control"/> -->
                <base-input alternative="" label="Parameters" placeholder="">
                    <div v-if="this.paramsOptions.length > 1">
                        <a-select v-if="selectedButton.action != 'payment'" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedButton.params">
                            <a-select-option v-for="param in paramsOptions" :key="param" :value="param">{{param}}</a-select-option>
                        </a-select>
                        <a-select v-else style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedButton.params">
                            <a-select-option v-for="param in paramsOptions" :key="param.code" :value="[param.code]">{{param.name}} ({{param.code}})</a-select-option>
                        </a-select>
                    </div>
                    <div v-else>
                        <a-select disabled mode="tags" v-model='selectedButton.params' style="width: 100%;" input-classes="form-control"></a-select>  
                    </div>
                </base-input>

                <base-input alternative="" label="Shortcut Key" placeholder="">
                    <a-select style="width: 100%" placeholder="Please select a function key" optionFilterProp="children"  v-model="selectedButton.id">
                          <a-select-option v-for="functionKey in (subMenuKeys.filter(n => !takenSubMenuKeys.includes(n)))" :key="functionKey" :value="functionKey">{{functionKey}}</a-select-option>
                    </a-select>
                </base-input>
                <a-switch class="float-right" checked-children="Change on Item Scan" un-checked-children="Change on Item Scan" v-model="selectedButton.ongoingTrans">Enable chnage function key on item scan</a-switch>
                <a-switch class="float-right" checked-children="Enabled" un-checked-children="Enabled" v-model="selectedButton.isEnable"/>

                <br/><br/>

                <div v-if="selectedButton.ongoingTrans == true">
                    <base-input alternative="" label="Label" placeholder="" v-model="ongoing.label" input-classes="form-control"/>
                    
                    <!-- <base-input alternative="" label="Action"  v-model="ongoing.action" input-classes="form-control"/> -->
                    <base-input alternative="" label="Action" placeholder="">
                        <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="ongoing.action" @change="subMenuActionOngoingChange">
                            <a-select-option v-for="action in actions" :key="action" :value="action">{{action}}</a-select-option>
                        </a-select>
                    </base-input>
                    <base-input alternative="" label="Parameters" placeholder="">
                    <div v-if="this.paramsOptions3.length > 1">
                        <a-select v-if="ongoing.action != 'payment'" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="ongoing.params">
                            <a-select-option v-for="param in paramsOptions3" :key="param" :value="param">{{param}}</a-select-option>
                        </a-select>
                        <a-select v-else style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="ongoing.params">
                            <a-select-option v-for="param in paramsOptions3" :key="param.code" :value="[param.code]">{{param.name}} ({{param.code}})</a-select-option>
                        </a-select>
                    </div>
                    <div v-else>
                        <a-select disabled mode="tags" v-model='ongoing.params' style="width: 100%;" input-classes="form-control"></a-select>  
                    </div>
                </base-input>

                    <!-- <base-input alternative="" label="Parameters" placeholder="">
                        <a-select  mode="tags" v-model='ongoing.params' style="width: 100%;" placeholder='Please define parameters here' input-classes="form-control"></a-select>  
                    </base-input> -->

                    <a-switch class="float-right" checked-children="Enabled" un-checked-children="Enabled" v-model="ongoing.isEnable"/>
                </div>
                
                
                <!-- <a-checkbox data-id="system_module.name" @change="onCheckChange(system_module.id)" :checked="checkedValues.includes(system_module.id)">{{system_module.name}}</a-checkbox> -->
                <br><br>
                <div class="list-group list-group-flush">
                    <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                        <div class="row">
                            <div class="col-md-6">MODES</div>
                            <div class="col-md-6 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addMode', {}, 0)"> <span class="fa fa-plus" /></base-button></div>
                        </div>
                    </div>
                    <!-- underscorejs -->
                    <div v-if="selectedButton.modes && !_.isEmpty(selectedButton.modes)">
                        <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(mode, index) in selectedButton.modes" :key="index">
                            <div class="row">
                               <div class="col-md-8">
                                   <a-dropdown>
                                     <a class="ant-dropdown-link" href="#">
                                       <span class="fa fa-ellipsis-v"></span> 
                                     </a>
                                     <a-menu slot="overlay">
                                       <a-menu-item key=1 @click="showDrawer('editMode', mode, index)"> Edit - {{mode.name}} ({{mode.label}}) </a-menu-item>
                                       <a-menu-item key=2 > 
                                         <a-popconfirm title="You are about to delete this menu?" okText="Delete" cancelText="Cancel" @confirm="deleteMode(mode.name)">
                                           Delete - {{mode.name}} ({{mode.label}})
                                         </a-popconfirm>
                                       </a-menu-item>
                                     </a-menu>
                                   </a-dropdown> &nbsp; 
                                   {{mode.name}} ({{mode.label}})
                               </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <a-empty class='mt-5' :image-style="{height: '50px',}" >
                            <span slot="description"> No modes to display. </span>
                        </a-empty>
                    </div>
                </div>


                <br/><br/><br/><br/><br/><br/>
                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button v-if="formType == 'editSubMenu'" class="btn btn-success" @click.prevent="updateSubMenu()">Save</button>
                    <button v-else class="btn btn-success" @click.prevent="createSubMenu">Create</button>
                    <!-- <button class="btn" @click.prevent="onClose">Cancel</button> -->
                </div>
            </form>
        </a-drawer>

         <div class="" style="min-height: 100%">
           <div class="card-header border-0">
               <div class="row align-items-center">
                   <div class="col-md-12"><br></div>
                   <div class="col-md-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                       
                       <div class="list-group list-group-flush">
                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                <div class="row">
                                    <div class="col-md-12">FUNCTION KEY GROUPS</div>
                                    <!-- <div class="col-md-6 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addMenu', selectedMenu, 0)">+ Add Menu</base-button></div> -->
                                </div>
                            </div>
                            <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(functionKeyGroup, index) in functionKeyGroups" :key="index" :class="[{selected2: selectedMainMenu == index}]">
                                 <div class="row" @click="setMainMenu(index)">
                                    <div class="col-md-8">{{functionKeyGroup.name}}</div>
                                    <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                 </div>
                             </div>  
                        </div>
                   </div>
                   <div class="col-md-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                       <div class="list-group list-group-flush">
                               <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                   <div class="row">
                                       <div class="col-md-4">BUTTONS</div>
                                       <div v-if="defaultGroups.groups[selectedMainMenu].length < 4" class="col-md-8 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addSubMenu', selectedMenu, 0)">+ Add Button</base-button></div>
                                   </div>
                               </div>
                        </div>
                       <draggable :key="draggableKey2" :list="defaultGroups.groups[selectedMainMenu]"  class="list-group" @start="dragging = true" @end="dragging = false">
                            <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(subMenu, index) in defaultGroups.groups[selectedMainMenu]" :key="subMenu.id">
                                <div class="row">
                                   <div class="col-md-8">
                                       <a-dropdown>
                                         <a class="ant-dropdown-link" href="#">
                                           <span class="fa fa-ellipsis-v"></span> 
                                         </a>
                                         <a-menu slot="overlay">
                                           <a-menu-item key=1 @click="showDrawer('editSubMenu', subMenu, index)"> Edit - {{subMenu.label}} </a-menu-item>
                                           <a-menu-item key=2 > 
                                             <a-popconfirm title="You are about to delete this menu?" okText="Delete" cancelText="Cancel" @confirm="deleteSubMenu(index)">
                                               Delete - {{subMenu.label}}
                                             </a-popconfirm>
                                           </a-menu-item>
                                         </a-menu>
                                       </a-dropdown> &nbsp; 
                                       {{subMenu.label}}
                                   </div>
                                </div>
                            </div>
                        </draggable>

                   </div>

               </div>
           </div>
         </div>  
        </a-spin>
</template>

<script>

import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex'
import HTTPRequest from '../controllers/httpRequest.js'

var component_x;

export default {
    components: {
        draggable
    },
    data: function(){
            return {
                paymentTypes: [],
                modeFormKey: 0,
                selectedMode: {},
                modeDrawerVisible: false,
                selectedButton: {},
                selectedGroup: null,
                functionKeyGroups: [{name: "Group 1"}, {name: "Group 2"}, {name: "Group 3"}],
                draggableKey2: 0,
                selectedMainMenu: 0,
                spinning: false,
                drawerVisible: false,
                formType: null,
                formType2: null,
                // selectedMenu: {},
                // takenMenuKeys: [],
                takenSubMenuKeys: [],
                paramsOptions2: [],
                paramsOptions3: [],
                paramsOptions4: [],
                paramsOptions: [],
                actions: ["auditTrailReport", "baggerLookup", "abortReceipt", "cashFloat", "changeQuantity", "changeTransactionMode", 
                            "collectionReport", "configure", "customerLookup", "delivery", "eJournalReport", "forceFullSynchronize",
                            "healthChecker", "itemDiscount", "itemLookup", "mainMenu", "operatorDeclaration", "overallDiscount", "payment",
                            "pickUp", "posLock", "posReset", "priceInquiry", "quitApp", "reprintReceipt", "resendTransactions", "resumeTransactionLookup",
                            "salesmanLookup", "salesReport", "scPwdReport", "signOff", "suspendCurrentTransaction", "viewSalesReturnsHistory", "viewShortcutKeysCheatSheet",
                            "voidAllItems", "voidLine", "voidReturnReport", "receiptVoid", "coupon", "returnTransaction", "operatorXReading"],
                actionParams: {
                    changeQuantity: ["selectedProduct"],
                    itemDiscount: ["selectedProduct"],
                    mainMenu: ["selectedProduct"],
                    salesmanLookup: ["SPL", "S"],
                    scPwdReport: ["S", "D"],
                    voidLine: ["selectedLine"],
                    voidReturnReport: ["R", "V"],
                    returnTransaction: ["salesReference"]
                    // payment: ["selectedProduct"],
                },
                subMenuKeys: ["f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "f10", "f11", "f12"],
                // subMenuKeys: ["btnF1", "btnF2", "btnF3", "btnF4", "btnF5", "btnF6", "btnF7", "btnF8", "btnF9", "btnF10", "btnF11", "btnF12"],
                // menuKeys: ["btnF1", "btnF2", "btnF3", "btnF4", "btnF5", "btnF6", "btnF7", "btnF8", "btnF9", "btnF10", "btnF11", "btnF12"],
                index: 0,
                settingCode: null,
                ongoing: {},
                ongoing2: {},
                defaultGroups: {
                "groups" :[
                    [
                        {
                            "id": "f1",
                            "label": "Main Menu",
                            "action": "mainMenu",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f2",
                            "label": "Item Search",
                            "action": "itemLookup",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f3",
                            "label": "Void Line",
                            "action": "voidLine",
                            "params": "selectedLine",
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f4",
                            "label": "Void Transaction",
                            "action": "voidTransaction",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        }
                    ],
                    [
                        {
                            "id": "f5",
                            "label": "Add Customer",
                            "action": "customerLookup",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f6",
                            "label": "Add Bagger",
                            "action": "baggerLookup",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f7",
                            "label": "Return",
                            "action": "changeTransactionMode",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f8",
                            "label": "Lock",
                            "action": "posLock",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        }
                    ],
                    [
                        {
                            "id": "f9",
                            "label": "Cash",
                            "action": "payment",
                            "params": "CASH",
                            "isEnable": true,
                            "modes": {
                                "RETURN": {
                                "name": "RETURN",
                                "label": "Cash",
                                "action": "returnTransaction",
                                "params": "salesReference",
                                "isEnable": "true"
                                }
                            }
                        },{
                            "id": "f10",
                            "label": "Card",
                            "action": "payment",
                            "params": "CREDIT",
                            "isEnable": true,
                            "modes": {}
                        },{
                            "id": "f11",
                            "label": "Main Menu",
                            "action": "payment",
                            "params": "EPS",
                            "isEnable": true,
                            "modes": {}
                        },
                        {
                            "id": "f12",
                            "label": "Other",
                            "action": "payment",
                            "params": null,
                            "isEnable": true,
                            "modes": {}
                        }
                    ]
                ]
    }
            }
    },
    mounted: async function() {
        component_x = this
        // console.log("***************")
        console.log(this.$attrs.defaultValue)
        this.spinning = true
        if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null)
            this.defaultGroups = this.$attrs.defaultValue
        else
            this.defaultGroups = this.defaultGroups

        this.settingCode = this.$attrs.settingCode
        this.defaultGroups.groups.map(x => {
            x.map(y => {
                if(y.modes == null || y.modes == undefined){
                    y.modes = {}
                }
                this.takenSubMenuKeys.push(y.id)    
            })
        })
        this.paymentTypes = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
        this.spinning = false
        this.setMainMenu(0);
    },
    watch: {
        defaultGroups: {
        handler: function() {
            var configValues = {}
            configValues[this.settingCode] = this.defaultGroups
            component_x.$emit("changeValue", configValues)
        },
        deep: true
    }
    },
    methods: {
        selectedMenuActionChange(value){
            this.selectedMode.action = value
            if(value == "payment"){
                this.paramsOptions2 = this.paymentTypes
            } else {
                if(this.actionParams[value] != undefined){
                    if( this.actionParams[value].length == 1){
                        this.selectedMode.params = this.actionParams[value];
                        this.paramsOptions2 = []
                    }else{
                        this.paramsOptions2 = this.actionParams[value]
                    }
                }else{
                    this.selectedMode.params = null
                    this.paramsOptions2 = []
                }
            }

        },
        selectedMenuActionOngoingChange(value){
            this.ongoing2.action = value
            if(value == "payment"){
                this.paramsOptions4 = this.paymentTypes
            } else {
                if(this.actionParams[value] != undefined){
                    if( this.actionParams[value].length == 1){
                        this.ongoing2.params = this.actionParams[value];
                        this.paramsOptions4 = []
                    }else{
                        this.paramsOptions4 = this.actionParams[value]
                    }
                }else{
                    this.ongoing.params = null
                    this.paramsOptions4 = []
                }
            }

        },
        subMenuActionOngoingChange(value){
            this.ongoing.action = value;
            
            if(value == "payment"){
                this.paramsOptions3 = this.paymentTypes
            } else {
                if(this.actionParams[value] != undefined){
                    if( this.actionParams[value].length == 1){
                        this.ongoing.params = this.actionParams[value];
                        this.paramsOptions3 = []
                    }else{
                        this.paramsOptions3 = this.actionParams[value]
                    }
                }else{
                    this.ongoing.params = null
                    this.paramsOptions3 = []
                }
            }
            
        },
        subMenuActionChange(value){
            this.selectedButton.action = value;
            
            if(value == "payment"){
                this.paramsOptions = this.paymentTypes
            } else {
                if(this.actionParams[value] != undefined){
                    if( this.actionParams[value].length == 1){
                        this.selectedButton.params = this.actionParams[value];
                        this.paramsOptions = []
                    }else{
                        this.paramsOptions = this.actionParams[value]
                    }
                }else{
                    this.selectedButton.params = null
                    this.paramsOptions = []
                }
            }
            
        },
        setMainMenu(menu){
            this.selectedMainMenu =  menu;
            this.selectedGroup = this.defaultGroups.groups[menu]
            this.takenSubMenuKeys = [];
            this.defaultGroups.groups.map(x => {
                x.map(y => {
                    this.takenSubMenuKeys.push(y.id)    
                })
            })
            // console.log("------")
            // console.log(this.takenSubMenuKeys)
        },
        showDrawer(type, selected, index){
            if(type == 'addMode' || type == 'editMode'){
                // console.log(selected);

                if(selected.name == undefined && type == 'editMode'){
                    selected.name = "RETURN"
                }

                this.formType2 = type
                this.modeDrawerVisible = true
                this.selectedMode = selected;
                if(this.selectedMode.ongoing != undefined)
                    this.ongoing2 = this.selectedMode.ongoing
                return;
            }

            if(type == 'editSubMenu'){
                this.selectedButton = this.selectedGroup[index]
                if(this.selectedButton.ongoing != undefined)
                    this.ongoing = this.selectedButton.ongoing
            }
                
            this.drawerVisible = true;
            this.formType = type;
            this.selectedMenu = selected;
            this.index = index
        },
        onClose2(){
            this.ongoing2 = {}
            this.modeDrawerVisible = false
            this.paramsOptions2 = []
            this.paramsOptions4 = []
        },
        onClose(){
            this.ongoing = {}
            this.drawerVisible = false;
            this.formType = null;
            this.selectedMenu = {};
            this.selectedButton = {};
            this.index = 0;
            this.paramsOptions = [];
            this.paramsOptions3 = []
        }, 
        validateSubMenu(index){
            var s = this.selectedButton
            if(_.isEmpty(s.label) || _.isEmpty(s.action) || _.isEmpty(s.id)){
                return false;
            }else {
                return true;
            }
        },
        deleteSubMenu(index){
            this.defaultGroups.groups[this.selectedMainMenu].splice(index, 1)
            this.takenSubMenuKeys = [];
            this.defaultGroups.groups.map(x => {
                x.map(y => {
                    this.takenSubMenuKeys.push(y.id)    
                })
            })
            this.$notification['success']({
              message: 'Success',
              description: "Button deleted successfully"
            });
            // array.splice(index, 1);
        },
        updateSubMenu(index){
            if(this.validateSubMenu(index)){
                // this.menus[this.index] = this.selectedMenu
                if(this.selectedButton.ongoingTrans == true)
                    this.selectedButton.ongoing = this.ongoing
                else
                    this.selectedButton.ongoing = {}

                this.defaultGroups.groups[this.selectedMainMenu][index] = this.selectedButton
                // this.selectedMainMenu.subMenu[this.index] = this.selectedMenu
                this.takenSubMenuKeys = [];
                this.defaultGroups.groups.map(x => {
                    x.map(y => {
                        this.takenSubMenuKeys.push(y.id)    
                    })
                })
                this.$notification['success']({
                  message: 'Success',
                  description: "Function group successfully updated"
                });
                this.onClose()
            } else {
                this.$notification['error']({
                  message: 'Failed',
                  description: "Please check your inputs."
                });
            } 
        },
        createSubMenu(){
            if(this.validateSubMenu()){
                this.defaultGroups.groups[this.selectedMainMenu].push(this.selectedButton)
                // this.menus.push(this.selectedMenu)
               this.takenSubMenuKeys = [];
                this.defaultGroups.groups.map(x => {
                    x.map(y => {
                        this.takenSubMenuKeys.push(y.id)    
                    })
                })
                this.$notification['success']({
                  message: 'Success',
                  description: "Button successfully created"
                });
                this.onClose()
            } else {
                this.$notification['error']({
                  message: 'Failed',
                  description: "Please check your inputs."
                });
            }
        },
        createMode(){
            // console.log(this.selectedButton,this.selectedMode['name'], this.selectedMainMenu, this.index)
            // console.log(this.defaultGroups.groups[this.selectedMainMenu][this.index])
            this.defaultGroups.groups[this.selectedMainMenu][this.index].modes[this.selectedMode.name] = this.selectedMode
            this.$notification['success']({
              message: 'Success',
              description: "Mode successfully created"
            });
            this.defaultGroups = this.defaultGroups
            this.onClose2()
        },
        updateMode(){
            if(this.selectedMode.ongoingTrans == true)
                this.selectedMode.ongoing = this.ongoing2
            else
                this.selectedMode.ongoing = {}

            this.defaultGroups.groups[this.selectedMainMenu][this.index].modes[this.selectedMode.name] = this.selectedMode
            this.$notification['success']({
              message: 'Success',
              description: "Mode successfully update"
            });
            this.defaultGroups = this.defaultGroups
            this.onClose2()
        },
        deleteMode(name){
            // console.log(this.defaultGroups.groups[this.selectedMainMenu][this.index].modes[name]) 
            delete this.defaultGroups.groups[this.selectedMainMenu][this.index].modes[name];
            this.$notification['success']({
              message: 'Success',
              description: "Mode successfully deleted"
            });
            this.defaultGroups = this.defaultGroups
            this.modeFormKey++;
        }
    },
    computed: {
       ...mapState(['endPoint']),
    },
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>